export const SocialLinkErrors = {
  GA_CODE_ERROR: 'Invalid google analytics tracking code.',
  GA4_CODE_ERROR: 'Invalid google analytics 4 tracking code. ',
  GTM_CODE_ERROR: 'Invalid google tag manager tracking code.',
  FB_PIXEL_CODE_ERROR: 'Invalid facebook pixel tracking ID',
  WEBSITE_URL_ERROR: 'Invalid Store Website URL',
  FB_URL_ERROR: 'Invalid Facebook URL',
  INSTA_URL_ERROR: 'Invalid Instagram URL',
  GBP_URL_ERROR: 'Invalid Google Business Page URL',
  TA_URL_ERROR: 'Invalid Trip Avisor URL',
  T_URL_ERROR: 'Invalid Tiktok URL',
  TX_URL_ERROR: 'Invalid Twitter X URL',
  CARDIT_URL_ERROR: 'Invalid Cardito URL',
  ERROR_LIST: [
    'Invalid Store Website URL',
    'Invalid Facebook URL',
    'Invalid Instagram URL',
    'Invalid Cardito URL',
    'Invalid google analytics tracking code.',
    'Invalid facebook pixel tracking ID',
  ],
};
